import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=4f015c1a&"
import script from "./ReferAFriend.vue?vue&type=script&lang=ts&"
export * from "./ReferAFriend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports